export const passwordMinLength = 8;
export const passwordMaxLength = 128;
export const emailMinLength = 1;
export const emailMaxLength = 75;
export const emailLocalLength = 64;
export const nameMinLength = 2;
export const nameMaxLength = 20;
